export const reverseHex = (hex: string) => {
    const match = hex.match(/[a-fA-F0-9]{2}/g)
    if (match === null) {
        return ''
    }
    return match.reverse().join('')
}

const convertHexToBigInt = (hex: string, reverse: boolean = false): string => {
    const hexId = reverse ? reverseHex(hex) : hex

    const add = (prevValue: string, item: string) => {
        const x = prevValue.split('').map(Number)
        const y = item.split('').map(Number)
        const r = []
        let c = 0
        while (x.length || y.length) {
            const s = (x.pop() || 0) + (y.pop() || 0) + c
            r.unshift(s < 10 ? s : s - 10)
            c = s < 10 ? 0 : 1
        }
        if (c) r.unshift(c)

        return r.join('')
    }

    let dec = '0'
    hexId.split('').forEach((chr) => {
        const n = parseInt(chr, 16)
        for (let t = 8; t; t >>= 1) {
            dec = add(dec, dec)
            if (n & t) dec = add(dec, '1')
        }
    })

    return dec
}

export default convertHexToBigInt
